//
//
//
//

export default {
  name: 'inline-desc'
}



// WEBPACK FOOTER //
// ./node_modules/_vux@2.9.2@vux/src/components/inline-desc/index.vue